/**
 * Fixed timestep accumulator. The render side calls `advance` every rAF frame;
 * logic advances in fixed steps, the returned alpha (0..1) is for interpolation.
 * see docs/05-architecture.md
 */
export class FixedLoop {
  private accumulator = 0;

  constructor(
    private readonly step: number,
    private readonly maxFrameTime: number,
  ) {}

  /**
   * @param dtSeconds real elapsed time (s)
   * @param update called on every fixed step
   * @returns alpha — progress toward the next step (render interpolation)
   */
  advance(dtSeconds: number, update: (step: number) => void): number {
    this.accumulator += Math.min(dtSeconds, this.maxFrameTime);
    while (this.accumulator >= this.step) {
      update(this.step);
      this.accumulator -= this.step;
    }
    return this.accumulator / this.step;
  }
}
